// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  background: #ffffff;

  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.card-header {
  --header-bg: #013868;
  background: var(--header-bg);
  color: #000;

  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;

  height: 60px;
  padding: 0 16px;
  box-shadow: 0 2px 6px rgba(1, 56, 104, 0.5);
}

.card-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-header-title {
  text-align: center;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.2px;
  color: #e6edf5;
  white-space: nowrap;

}

.card-header-right {
  justify-self: end;
  display: flex;
  align-items: center;
  gap: 10px;
}

.card-icon-button {
  width: 34px;
  height: 34px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  border: 0;
  cursor: pointer;

  background: #013868;
  color: #e6edf5;
  border-radius: 999px;
}

.card-icon-button:hover {
  background: rgba(255, 255, 255, 0.2);
}

.card-icon-button:active {
  transform: translateY(1px);
}

.card-icon-button:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.75);
  outline-offset: 2px;
}

.card-body {
  padding: 16px;
  display: flex;
  justify-content: center;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  height: auto;
  padding-bottom: 20px;
}

.card-body-content {
  width: 100%;
  max-width: 1500px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card-icon-button svg {
  stroke-linecap: round;
  stroke-linejoin: round;
}

.card-icon-button:hover svg {
  transform: scale(1.05);
}

.card-icon-button:active svg {
  transform: scale(0.98);
}

.login-logo-img1 {
  width: 130px;
  height: 60px;
  margin-left: -16px;
}

.stock-display {
  color: #e6edf5;
  font-size: large;
}

.profile-wrapper {
  position: relative;
}

.profile-dropdown {
  position: absolute;
  top: 42px;
  right: 0;
  background: white;
  border-radius: 8px;
  min-width: 180px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, .2);
  padding: 6px 0;
  z-index: 1000;
}

.profile-item {
  padding: 8px 14px;
  cursor: pointer;
  font-size: 14px;
}

.profile-item:hover {
  background: #f3f3f3;
}

.profile-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 6px 0;
}

.profile-item.logout {
  color: #c62828;
  font-weight: 500;
  text-align: center;
}

.card-header-right select {
  min-width: 0;

  background: #eef3f7;
  border-radius: 6px;
  border-color: #eef3f7;
  font: inherit;
  line-height: 1;
  padding: 6px;

  outline: none;
  font-size: 16px;

  padding-right: 18px;
  background-image: linear-gradient(45deg, transparent 50%, var(--muted) 50%),
    linear-gradient(135deg, var(--muted) 50%, transparent 50%);
  background-position: calc(100% - 12px) 52%, calc(100% - 7px) 52%;
  background-size: 5px 5px, 5px 5px;
  background-repeat: no-repeat;
  line-height: 15px;
  margin-right: 15px;
}`, "",{"version":3,"sources":["webpack://./src/web/component/Card/styles.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;;EAEnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,WAAW;;EAEX,aAAa;EACb,mCAAmC;EACnC,mBAAmB;;EAEnB,YAAY;EACZ,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,mBAAmB;;AAErB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;;EAEvB,SAAS;EACT,eAAe;;EAEf,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;;EAEZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,YAAY;;EAEZ,aAAa;EACb,eAAe;;EAEf,mBAAmB;EACnB;8DAC4D;EAC5D,gEAAgE;EAChE,iCAAiC;EACjC,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".card {\r\n  background: #ffffff;\r\n\r\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n}\r\n\r\n.card-header {\r\n  --header-bg: #013868;\r\n  background: var(--header-bg);\r\n  color: #000;\r\n\r\n  display: grid;\r\n  grid-template-columns: 1fr auto 1fr;\r\n  align-items: center;\r\n\r\n  height: 60px;\r\n  padding: 0 16px;\r\n  box-shadow: 0 2px 6px rgba(1, 56, 104, 0.5);\r\n}\r\n\r\n.card-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.card-header-title {\r\n  text-align: center;\r\n  font-weight: 500;\r\n  font-size: 20px;\r\n  letter-spacing: 0.2px;\r\n  color: #e6edf5;\r\n  white-space: nowrap;\r\n\r\n}\r\n\r\n.card-header-right {\r\n  justify-self: end;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.card-icon-button {\r\n  width: 34px;\r\n  height: 34px;\r\n\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  border: 0;\r\n  cursor: pointer;\r\n\r\n  background: #013868;\r\n  color: #e6edf5;\r\n  border-radius: 999px;\r\n}\r\n\r\n.card-icon-button:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.card-icon-button:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n.card-icon-button:focus-visible {\r\n  outline: 2px solid rgba(255, 255, 255, 0.75);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.card-body {\r\n  padding: 16px;\r\n  display: flex;\r\n  justify-content: center;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  min-height: 0;\r\n  height: auto;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.card-body-content {\r\n  width: 100%;\r\n  max-width: 1500px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.card-icon-button svg {\r\n  stroke-linecap: round;\r\n  stroke-linejoin: round;\r\n}\r\n\r\n.card-icon-button:hover svg {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.card-icon-button:active svg {\r\n  transform: scale(0.98);\r\n}\r\n\r\n.login-logo-img1 {\r\n  width: 130px;\r\n  height: 60px;\r\n  margin-left: -16px;\r\n}\r\n\r\n.stock-display {\r\n  color: #e6edf5;\r\n  font-size: large;\r\n}\r\n\r\n.profile-wrapper {\r\n  position: relative;\r\n}\r\n\r\n.profile-dropdown {\r\n  position: absolute;\r\n  top: 42px;\r\n  right: 0;\r\n  background: white;\r\n  border-radius: 8px;\r\n  min-width: 180px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, .2);\r\n  padding: 6px 0;\r\n  z-index: 1000;\r\n}\r\n\r\n.profile-item {\r\n  padding: 8px 14px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n.profile-item:hover {\r\n  background: #f3f3f3;\r\n}\r\n\r\n.profile-divider {\r\n  height: 1px;\r\n  background: #e0e0e0;\r\n  margin: 6px 0;\r\n}\r\n\r\n.profile-item.logout {\r\n  color: #c62828;\r\n  font-weight: 500;\r\n  text-align: center;\r\n}\r\n\r\n.card-header-right select {\r\n  min-width: 0;\r\n\r\n  background: #eef3f7;\r\n  border-radius: 6px;\r\n  border-color: #eef3f7;\r\n  font: inherit;\r\n  line-height: 1;\r\n  padding: 6px;\r\n\r\n  outline: none;\r\n  font-size: 16px;\r\n\r\n  padding-right: 18px;\r\n  background-image: linear-gradient(45deg, transparent 50%, var(--muted) 50%),\r\n    linear-gradient(135deg, var(--muted) 50%, transparent 50%);\r\n  background-position: calc(100% - 12px) 52%, calc(100% - 7px) 52%;\r\n  background-size: 5px 5px, 5px 5px;\r\n  background-repeat: no-repeat;\r\n  line-height: 15px;\r\n  margin-right: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
